import { useEffect, useState } from 'react';
import { adrift, isAdriftAvailable } from '../data/books';

export default function useAdriftAvailability() {
  const [available, setAvailable] = useState(isAdriftAvailable);

  useEffect(() => {
    let timer;
    const update = () => {
      clearTimeout(timer);
      const released = isAdriftAvailable();
      setAvailable(released);
      if (!released) {
        // Cap long waits to avoid the browser's maximum timeout delay.
        timer = setTimeout(update, Math.min(adrift.releaseAt - Date.now(), 86400000));
      }
    };
    update();
    window.addEventListener('focus', update);
    document.addEventListener('visibilitychange', update);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('focus', update);
      document.removeEventListener('visibilitychange', update);
    };
  }, []);

  return available;
}
